import { useEffect, useState } from "react"
import { Select, MenuItem, InputLabel, TextField, FormControl, Button} from "@mui/material"
import {
  Wrapper,
  HeaderWrapper,
  Header,
} from "../SettingsSection/SettingsSection.styles"
import { WorkQueuesRead } from "../../api/generated/models/WorkQueuesRead"
import { OperatingCompanyRead } from "../../api/generated/models/OperatingCompanyRead"
import DeleteModal from "../DeleteModal/DeleteModal"
import AddIcon from '@mui/icons-material/Add';
// @ts-ignore
import EditIcon from "../../assets/Edit.svg?react"
// @ts-ignore
import DeleteIcon from "../../assets/Trash.svg?react"
// @ts-ignore
import SaveIcon from '../../assets/Check.svg?react';
// @ts-ignore
import CancelIcon from '../../assets/X.svg?react';
import {
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridEventListener,
  GridRowEditStopReasons,
  GridAlignment
} from '@mui/x-data-grid';
import useShowError from "../../hooks/useShowError"
import { styled } from '@mui/system';
import {
  useCreateWorkList,
} from "../../hooks/WorkLists"
import { useAppSelector } from "../../app/hooks"
import { selectLGInternalUser } from "../../activeScreenSlice"


const StyledSelect = styled(Select)({
  height: '32px',
  width: '90%'
});


export interface Props {
  workListItems: Array<WorkQueuesRead>
  onUpdate: (workList: WorkQueuesRead) => any
  onDelete: (workList: WorkQueuesRead) => any
  opcosList: Array<OperatingCompanyRead>
}

const clientOnlyWorkLists: Record<string, boolean> = {}

export default function WorkLists(props: Props) {
  const LGInternalUser = useAppSelector(selectLGInternalUser);
  const [workLists, setWorkLists] = useState(
    props.workListItems,
  )

  const createWorkListMutation = useCreateWorkList().mutate
  const [workListToDelete, setWorkListToDelete] =
    useState<WorkQueuesRead | null>(null)

  const [isNewRowAdded, setNewRowAdded]=useState(false);
  useEffect(() => {
    setWorkLists((workLists) =>
      props.workListItems.map(
        (workList) =>
          workLists.find(({ id, name, opco_name }) => id === workList.id && name === workList.name && opco_name === workList.opco_name) || workList,
      ),
    )
  }, [props.workListItems])

  function removeWorkListItem(id: number) {
    setWorkLists((prevWorkLists) =>
      prevWorkLists.filter((prevItem) => prevItem.id !== id),
    )
  }

  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const showToast = useShowError();

  const handleRowEditStop: GridEventListener<'rowEditStop'> = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleCreateWl = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  }

  const handleDeleteClick = (params) => () => {
    if (clientOnlyWorkLists[params.id]) {
      removeWorkListItem(params.id)
      return
    }

    setWorkListToDelete(params.row)
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
    setNewRowAdded(false);
    const editedRow = rows.find((row) => row.id === id);
    if (editedRow?.isNew) {
      setWorkLists((prevWorkLists) =>
        prevWorkLists.filter((prevItem) => prevItem.id !== id),
      )
    }
  };

  const columns = [
    { field: 'name', headerName: 'Worklist Name',  flex: 3, editable: true, renderEditCell: (params) => (
      <TextField
        label="Name"
        name="description"
        value={params.value}
        onChange={(event) => {
          params.api.setEditCellValue({
            id: params.id,
            field: params.field,
            value: event.target.value,
          }, event);
        }}
        size="small"
        InputLabelProps={{ shrink: true }}
        placeholder="Worklist name here"
        variant="outlined"
        sx={{'& input': {height: '15px'}, width: '90%'}}
    />
    )},

    
    {
      field: 'opco_name',
      headerName: 'Business Unit Code',
      flex: 2,
      editable: true,
      renderEditCell: (params) => (
        <FormControl fullWidth size="small" variant="outlined" sx={{'& input': {height: '15px'}}}>
        <InputLabel id='opco-label' sx={{lineHeight: '16px'}}>BU code</InputLabel>
        <StyledSelect 
            labelId='opco-label'
            name="opco"
            value={params.value || ''}
            onChange={(event) => {
              params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value }, event);
            }}
            label="Business unit code"
            disabled={params.row.isDeleteProtected === "Yes" ? true : false}
        >
            {props.opcosList?.map(option => (
            <MenuItem key={option.id} value={option.name}>{option.name}</MenuItem>
          ))}
        </StyledSelect></FormControl>)
    },
    {
      field: 'isDeleteProtected',
      headerName: 'Core Worklist',
      flex: 2,
      editable: false,
      renderCell: (params) => params.value
    },
    {
      field: 'created_at',
      headerName: 'Creation Date',
      flex: 2,
      editable: false,
      renderCell: (params) => params.value
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: '',
      flex: 1,
      cellClassName: 'actions',
      align: 'right' as GridAlignment,
      headerAlign: 'center' as GridAlignment,
      getActions: (params) => {
        const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;
        
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label={clientOnlyWorkLists[params.id] ?  "Create" : "Save"}
              onClick={clientOnlyWorkLists[params.id] ? handleCreateWl(params.id) : handleSaveClick(params.id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(Number(params.id))}
              color="inherit"
            />,
          ];
        }
        

        return [
          <GridActionsCellItem
            icon={<EditIcon style={{ cursor: 'pointer' }} />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(params.id)}
            color="inherit"
            sx={{mr: 1}}
            disabled={LGInternalUser}
          />,
          <GridActionsCellItem
            icon={<DeleteIcon style={{ cursor: 'pointer' }} />}
            label="Delete"
            onClick={handleDeleteClick(params)}
            color="inherit"
            sx={
              params.row.isDeleteProtected === "Yes"
                ? { visibility: "hidden" }
                : undefined
            }
            disabled={LGInternalUser}
          />,
        ];
      },
    },
  ];
  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };

    if ((!newRow.name || newRow.name.trim() === '')) {
      throw new Error('Worklist name is required.');
    }

    if ((!newRow.opco_name || newRow.opco_name.trim() === '')) {
      throw new Error('Business unit code is required.');
    }

    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    if(clientOnlyWorkLists[newRow.id]) {
      createWorkListMutation(newRow, {onError: (error: any) => {
        handleCancelClick(Number(newRow.id))();
      }})
    } else {
      props.onUpdate(newRow);
    }
    return updatedRow;
  };

  const dataRowMapping = (data) => {
    return data?.map((wl) => ({
      id: wl.id?.toString(),
      name: wl.name,
      opco_name: wl.opco_name,
      type: 'string',
      align: 'left' as GridAlignment,
      headerAlign: 'left' as GridAlignment,
      isDeleteProtected: wl.is_delete_protected ? "Yes" : "No",
      created_at: wl.created_at?.split("T")[0],
    }));
  }
  function EditToolbar(props) {
  const { setRows, setRowModesModel } = props;
  
  const handleAddClick = () => {
    const id = Date.now()
    clientOnlyWorkLists[id] = true
    setNewRowAdded(true);

    setWorkLists((prevWorkLists) => [
      {
        id,
        name: "",
        slug: "",
        opco_name: null,
        opco_id: null,
        is_delete_protected: false,
        created_at: "",
        updated_at: "",
      }, ...prevWorkLists
    ])

    setRows((oldRows) => [
         {
        id,
        name: "",
        slug: "",
        opco_name: null,
        opco_id: null,
        is_delete_protected: false,
        isNew: true 
      },...oldRows]);
      setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
    }));
    
  };
  return (
    <GridToolbarContainer>
      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={handleAddClick}
        sx={{
            position: 'absolute',
            right: 0,
            top: '-40px',
            '& .MuiButton-startIcon': {
              mr: .5
            }
        }}
        disabled={LGInternalUser}
      >
        Create New Worklist
      </Button>
    </GridToolbarContainer>
    );
  }
  const rowClass = (e) => {
    if(!isNewRowAdded) {
      if(e.indexRelativeToCurrentPage % 2 === 0) {
        return "even-row"
      } else return "odd-row"
    } else if(isNewRowAdded) {
      if(e.indexRelativeToCurrentPage % 2 === 0) {
        return "odd-row"
      } else return "even-row"
    }
  }
  const noDataStyles = { height: workLists.length<1 ? 600 : '', width: workLists.length<1 ? '100%': '' };

  return (
    <Wrapper>
      <DeleteModal
        open={Boolean(workListToDelete)}
        header={`You are about to delete workqueue ${workListToDelete?.name}`}
        subheader="All invoices currently in this workqueue will be unassigned from their current user and sent to the default workqueue"
        onDelete={async () => {
          setRows(rows.filter((row) => row.id !== workListToDelete.id));
          await props.onDelete(workListToDelete!)
          setWorkListToDelete(null)
        }}
        onCancel={() => {
          setWorkListToDelete(null)
        }}
      />

      <HeaderWrapper>
        <Header>Worklists</Header>
      </HeaderWrapper>
      <div style={noDataStyles}> 
      <DataGrid
        rows={workLists?.length > 0 ? dataRowMapping(workLists):[]}
        columns={columns}
        editMode="row"
        onProcessRowUpdateError={err => showToast(err.message)}
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
        slots={{ toolbar: EditToolbar }}
        slotProps={{
          toolbar: { setRows, setRowModesModel },
        }}
        getRowClassName={(e) => rowClass(e)}
        hideFooterPagination
        hideFooter
        disableColumnFilter 
        sx={{
          border: "none",
          maxHeight: "none",
          width: "99%",
          '& .MuiBox-root': {
            maxHeight: "none",
          },
          '& .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within': {
              outline: 'none',
          },
          '& .MuiDataGrid-cell, & .MuiDataGrid-root, & .MuiDataGrid-columnHeaders': {
              border: 'none',
          },
          '& .MuiDataGrid-row--editing': {
            boxShadow: 'none',
          },
          '& .MuiDataGrid-cell, & .MuiDataGrid-cell--editing.MuiDataGrid-cell': {
              padding: '0 35px 0 0',
          },
          '& .MuiDataGrid-cell:first-of-type': {
              padding: '0 0 0 50px',
          },
          '& .MuiDataGrid-cell:last-child': {
              padding: '0 40px 0 0',
          },
          '& .MuiDataGrid-columnHeader': {
              padding: '0',
          },
          '& .MuiDataGrid-columnHeader:first-of-type': {
              padding: '0 0 0 50px',
          },
          '& .MuiDataGrid-row.even-row': {
              backgroundColor: 'var(--background-off-white)',
          },
          '& .MuiDataGrid-cellContent': {
              fontSize: '13px',
          },
          
      }}
      />
      </div>
    </Wrapper>
  )
}
